import React, { forwardRef, useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { useStore } from '../zustand';
import { TherapistModule } from './therapistModule';

export const PraxisTherapists = forwardRef(
  ({ therapistDescription, therapists, therapistTitle }, ref) => {
    const [therapistInView] = useIntersectionObserver(ref, {});

    const [setPraxisInView] = useStore(
      (state) => [state.setPraxisInView],
      shallow
    );

    useEffect(() => {
      if (therapistInView) {
        setPraxisInView({ 1: true });
      } else {
        setPraxisInView({ 1: false });
      }
    }, [therapistInView]);

    return (
      <TherapistModule
        ref={ref}
        pricing
        description={therapistDescription}
        therapists={therapists}
        title={therapistTitle}
      />
    );
  }
);
